import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const StyledSearchMobile = styled.div`
  ${rtl`
  box-shadow: ${theme.color['container-box-shadow']};
  background-color: ${theme.color.white};
  border-radius: ${toRem(6)};
  display: flex;
  align-items: center;
  &.mobile-search-page-form-container {
    button {
      span.t-font-xs {
        color: ${theme.color['dark-gray-13']};
        font-weight: 700;
      }
    }
  }
  &.search-form-adf{
    border-radius: 0 !important;
    padding:${toRem(16)} !important;
    span:nth-child(3).t-label-alt-s  {
      line-height:${toRem(20)};
    }
 
  }
  &.m-search-container {
    position: relative;
    height: ${toRem(72)};
    padding: ${toRem(22)} ${toRem(20)} ${toRem(24)};
  }
  @media ${theme.mediaQuery.smallMobile} {
    padding-left: ${toRem(16)};
    padding-right: ${toRem(16)};
  }
  button {
    width: 50%;
    text-align: left;
    background: transparent;
    padding: 0px;
    display: flex;
    border: none;
    flex-direction: column;
    &:first-child {
      border-right: ${toRem(1)} dashed ${theme.color['dark-gray-6']};
      padding-right: ${toRem(10)};
    }

    &.no-padding {
      border-right: none;
      padding: 0;
      width: 100%;
    }

    &.overflow-hidden {
      overflow: hidden;
    }

    &:nth-child(2) {
      padding-left: ${toRem(21)};
    }
  }

  span {
    &.dates-placeholder{
      white-space: nowrap;
      text-overflow: ellipsis;
      width:100%;
      overflow:hidden;
    }
    &.destination-input-label{
      text-transform: capitalize;
    }
    &:before {
      color: ${theme.color['light-orange-2']};
      padding-right: ${toRem(8)};
      font-size: ${toRem(13)};
    }
    &.hide-icon {
      &:before {
        display: none;
      }
    }
    &:nth-child(1) {
      display: none;
      padding-bottom: 0;
      &:before {
        padding-right: ${toRem(11)};
      }
    }
    &:nth-child(2) {
      padding-bottom: ${toRem(6)};
      text-transform: uppercase;
      letter-spacing: ${toRem(1.3)};
      @media ${theme.mediaQuery.smallMobile} {
        letter-spacing: ${toRem(1)};
      }
    }
    &:nth-child(3) {
      white-space: normal;
      text-overflow: ellipsis;
      overflow: visible;
      width: 100%;
      font-size: ${theme.fonts['fontL']};
      line-height: ${theme.fonts['lineHeightM']};
      color: ${theme.color['dark-gray-3']};
      &.t-label-alt-s {
        color: ${theme.color['black']};
        font-weight: 700;
        font-size: ${toRem(16)};
        line-height: ${toRem(22)};
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    &.search-date-stay {
      display: inline !important;
      color: #707070;
    }
  }
  .search-date-label {
    color: ${theme.color['dark-gray-3']};

    &.search-date-specific {
      color: #1c1c1c;
      font-size: ${toRem(16)};
      font-weight: 500;
      height: ${toRem(24)};
      line-height: ${toRem(24)};
    }
  }

  .search-form-edit-button {
    display: flex;
    justify-content: center;
    border: ${toRem(1)} solid  ${theme.color['dark-gray-1']};
    height: ${toRem(34)};
    line-height:${toRem(17)};
    padding: 0 ${toRem(16)} !important;
    width: unset !important;
    span:nth-child(1) {
      display: block;
    }
    .nowrap {
      white-space: nowrap;
    }
    .edit-cta-content {
      width: max-content;
    }
  }

  .search__container-hide-destination {
    .search-primary-destination {
      display: none !important;
    }
  }
`}
`;
